import type {
  UpdateGoodsInfoResponse,
  UpdateGoodsInfoItem,
  GoodsItem
} from './types'
import paymentConfig from '../../../constants/payment'
import CONFIG from '../../../constants/config'

// 补齐补差价商品数据结构
export function mapUpdateGoodsInfoToGoods(
  updateData: UpdateGoodsInfoResponse
): GoodsItem[] {
  if (!updateData || !updateData.goodsInfo || updateData.goodsInfo.length === 0)
    return []

  const remainingMonth =
    typeof updateData.remainingMonth === 'number' &&
    updateData.remainingMonth > 0
      ? Math.max(1, Math.round(updateData.remainingMonth))
      : 12

  const mapped: GoodsItem[] = (
    updateData.goodsInfo as UpdateGoodsInfoItem[]
  ).map((item) => {
    const pricePerMonth = Math.round((item.price || 0) / remainingMonth)
    return {
      id: item.id,
      price: item.price,
      type: 1,
      content: {
        title: '补差价升级',
        sign: '最划算',
        footer: `升级剩余${updateData.remainingMonth}个月`,
        vipType: 12,
        vipKind: item.vipKind,
        subTitle: `升级剩余${updateData.remainingMonth}个月`,
        pricePerMonth,
        monthCnt: remainingMonth
      }
    }
  })

  return mapped
}

// 根据 tabKey 过滤出对应 vipKind 的商品
export function getGoodsForTab(
  goodsList: GoodsItem[],
  tabKey: string
): GoodsItem[] {
  const kindMap: Record<string, number> = {
    basic: CONFIG.VIP_KIND.VIP,
    advanced: CONFIG.VIP_KIND.VVIP,
    super: CONFIG.VIP_KIND.SVIP,
    enterprise: CONFIG.VIP_KIND.EVIP
  }
  const targetKind = kindMap[tabKey] || CONFIG.VIP_KIND.VIP
  return (goodsList || []).filter((g) => g?.content?.vipKind === targetKind)
}

// 根据优先级规则从指定 tab 的商品中选出 primary 和 secondary
export function getPrimarySecondaryForTab(
  goodsList: GoodsItem[],
  tabKey: string
) {
  const candidates = getGoodsForTab(goodsList, tabKey)
  // 补差价升级商品优先作为 primary
  const priceDiffItem = candidates.find((g) => g?.content?.vipType === 12)
  const primary =
    priceDiffItem ||
    candidates.find(
      (g) => g?.content?.vipType === paymentConfig.paymentType.multipleYear
    ) ||
    candidates.find(
      (g) => g?.content?.vipType === paymentConfig.paymentType.multipleMonth
    ) ||
    candidates[0] ||
    null
  // 当 primary 为补差价升级时，secondary 只从非订阅型商品（type !== 2）中选取
  const secondaryCandidates = priceDiffItem
    ? candidates.filter((g) => g && g !== primary && g.type !== 2)
    : candidates.filter((g) => g && g !== primary)
  const secondary =
    secondaryCandidates.find(
      (g) =>
        g?.content?.vipType === paymentConfig.paymentType.singleYear ||
        g?.content?.vipType === paymentConfig.paymentType.singleMonth
    ) ||
    secondaryCandidates[0] ||
    null
  return { primary, secondary }
}

/** 卡片下方、申请发票文案之前的一行：v2 goodsUI.bottomText → content.footer；无则连续包年用默认兜底 */
export function getRenewalHintBeforeInvoiceLine(
  selectedGoods: GoodsItem | null | undefined
): string {
  const footer = selectedGoods?.content?.footer?.trim()
  if (footer) return footer
  if (
    selectedGoods?.content?.vipType === paymentConfig.paymentType.multipleYear
  ) {
    return '到期按198/年续费，可随时取消'
  }
  return ''
}
